import React, { FC, memo } from 'react'

import { BrowserNotifications } from 'modulesCommon/Notifications/components'
import { useBrowserNotifications } from 'modulesCommon/serviceHooks'

const BrowserNotificationsContainer: FC = memo(() => {
  const { notificationsData, toggleSubscription } = useBrowserNotifications()

  return <BrowserNotifications data={notificationsData} toggleSubscription={toggleSubscription} />
})

export default BrowserNotificationsContainer
